import { useQuery } from '@tanstack/react-query';
import { fetchOrganizationActionsInfo } from '@/api/v4/organization-actions-info';
import { fetchSpotlightOrganizationActionsInfo } from '@/api/v4/spotlight.api';
import { QueryKey } from '@/config/query-client';

import { companyIdState } from '../company.state';
import {
  type CompanyFetchMode,
  useCompanyFetchMode,
} from '../company-fetch-context';
import { useAtomValue } from 'jotai';

const companyActionsInfoFetchers: Record<
  CompanyFetchMode,
  (organizationId: string) => ReturnType<typeof fetchOrganizationActionsInfo>
> = {
  general: fetchOrganizationActionsInfo,
  spotlight: fetchSpotlightOrganizationActionsInfo,
};

export const useCompanyActionsInfo = () => {
  const organizationId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  const fetchActionsInfo = async () => {
    if (!organizationId) return;

    return companyActionsInfoFetchers[fetchMode](organizationId);
  };

  return useQuery({
    queryKey: [QueryKey.CompanyActionsInfo, fetchMode, organizationId],
    queryFn: fetchActionsInfo,
    enabled: !!organizationId,
    staleTime: 1000 * 60 * 5,
  });
};
